export const RootPrefix = 'invoice_page';
export const PurchaseOrderFormId = 'purchase_order_form';
